// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"183":"71e104af","201":"228b39f5","369":"d25a7f01","465":"c7acdd68","695":"1a4e618e","940":"891e4a89"}[chunkId] + ".css";
};